import React from 'react';
import { Container, Heading, SimpleGrid } from '@hover/blueprint';
import MaterialDetails from './MaterialDetails';
import type { IRoofingMaterial } from '../../../interfaces/IRoofingMaterial';
import { SIDING_MATERIALS } from '../../../constants/vinylSidingEstimator';

const RoofingMaterials: React.FC = () => (
  <Container
    px={{ base: 500, tablet: '56px' }}
    maxW="1312px"
    centerContent
    mb={1000}
  >
    <Heading as="h2" size={{ base: 500, tablet: 600, desktop: 700 }} isLight>
      Siding Materials
    </Heading>
    <Heading
      as="p"
      maxW="5xl"
      textAlign={{ base: 'center', desktop: 'center' }}
      marginBottom={{ base: 800, tablet: '80px' }}
      size={{ base: 300, tablet: 500 }}
      isDisplay
    >
      There are a variety of factors that will determine if the type of siding
      is good for your house or not. However, for all siding options, siding is
      measured in “Squares” when estimating siding materials. A ‘square’ is a
      unit that covers 100 square feet. Add up all of your square footage
      measurements to get the total and divide by 100 to determine the number of
      siding “squares” you will need to purchase. Using the total square
      footage, you can get total cost estimates for each material. Here are a
      few popular materials you can choose from:
    </Heading>
    <SimpleGrid columns={{ base: 1, desktop: 3 }} spacing="60px" maxW="1089px">
      {SIDING_MATERIALS.map((material: IRoofingMaterial) => (
        <MaterialDetails
          body={material.body}
          title={material.title}
          key={material.id}
        />
      ))}
    </SimpleGrid>
  </Container>
);

export default RoofingMaterials;
